import React from 'react';
import { H1, H3 } from '~/shared/Typography';
import { FullScreenBox, Section } from '~/shared/Theme';

const NotFound = () => {

    return (
        <FullScreenBox>
            <Section
                fullScreen
                alignItems="center"
                justifyContent={'center'}
                px={4}
            >
                <H1 fontSize={'8xl'}>404</H1>
                <H3 textAlign={'center'}>
                    It looks like that page does not exist - please check the URL and try again
                </H3>
            </Section>
        </FullScreenBox>
    );
};

export default NotFound;
